<template>
	<div class="projectNew" >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-orderManage Icon"></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text">/ 项目任务 / 批量新建订单</span>
		</div>
		<div class="NewOrderContent box-shadow" :style="{'min-height': windowSizeHeight-120 +'px'}">
			
			<el-row class="step_BOX" style="border-bottom: 1px solid #e8e8e8;">
				<el-col :span="7" class="step step01 ">
					<div class="fl font_Box">
						<span class="fontStepF">01</span>
					</div>
					<div class="fl cont_Box">
						<div>
							<h3>项目信息</h3>
							<p>项目名称、类型、预算等</p>
						</div>
					</div>
				</el-col>
				<el-col :span="8" class="step step02 ">
					<div class="fl step hintDian1">
						<span>●</span>
						<span>●</span>
						<span>●</span>
					</div>
					<div class="fl font_Box">
						<span class="fontStepF">02</span>
					</div>
					<div class="fl cont_Box">
						<div>
							<h3>人员导入</h3>
							<p>批量导入人员数据</p>
						</div>
					</div>
				</el-col>
				<el-col :span="8" class="step step03 ">
					<div class="fl step hintDian2">
						<span>●</span>
						<span>●</span>
						<span>●</span>
					</div>
					<div class="fl font_Box">
						<span class="fontStepF">03</span>
					</div>
					<div class="fl cont_Box">
						<div>
							<h3>数据校验</h3>
							<p>检查数据是否有误</p>
						</div>
					</div>
				</el-col>
			</el-row>
			
			<!-- 步骤一 -->
			<div class="stepOne  m-t-15 " v-if="active==1">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="任务类型" prop="taskType" style="display:inline-block">
						<el-select v-model="ruleForm.taskType" filterable placeholder="请选择任务类型" style="width: 220px;" @change="taskTypeChange">
							<el-option v-for="item in taskTypeArr" :key="item.project_cate" :label="item.project_cate" :value="item.project_cate"></el-option>
						</el-select>
						<el-select class="m-l-5" v-if="modelShow" v-model="activeModel" filterable placeholder="请选择模板" style="width: 150px;" @change="modelChange">
							<el-option v-for="(item,index) in modelArr" :key="index" :label=" item.project_name " :value="index"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="省份" prop="province">
						<el-select v-model="ruleForm.province" filterable placeholder="请选择省" @change="provinceChange" style="width: 220px;">
							<el-option v-for="(item,index) in provinceArr" :key="item.name" :label="item.name" :value="item.name">
								<p @click="provinceClick(item.id)">{{ item.name }}</p>
							</el-option>
						</el-select>
						<span class="font-12 text-color-default cursor-pointer m-l-5" v-if="lastAddress.district" @click="lastAddressBtn">(上一次选择的是 <span class="text-color-blue font-underline">{{lastAddress.district}}</span> )</span>
					</el-form-item>
					<el-form-item label="城市"  prop="city">
						<el-select v-model="ruleForm.city" filterable placeholder="请选择市" style="width: 220px;">
							<el-option v-for="(item,index) in cityArr" :key="item.name" :label="item.name" :value="item.name">
								<p>{{ item.name }}</p>
							</el-option>
						</el-select>
					</el-form-item>
					<!-- :picker-options="pickerOptions"  required-->
					<el-form-item label="项目时间" prop="dateAll">
						<el-date-picker style="width: 380px;" v-model="ruleForm.dateAll"  type="daterange" range-separator="至" @change="dateChange"
						 value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="项目名称" prop="name">
						<div style="width: 380px;">
							<el-input v-model.trim="ruleForm.name" placeholder="请输入"></el-input>
						</div>
					</el-form-item>
					<el-form-item label="任务描述" prop="remark">
						<div style="max-width: 546px;">
							<el-input type="textarea" :rows="6" v-model="ruleForm.remark"></el-input>
						</div>
					</el-form-item>
					<el-form-item label="详细地址" prop="address">
						<div style="max-width: 546px;">
							<el-input v-model="ruleForm.address"></el-input>
						</div>
					</el-form-item>
					<el-form-item>
						<span class="btnOK" @click="submitForm('ruleForm')" style="margin-right: 20px;">下一步-&gt;人员导入</span>
					</el-form-item>
				</el-form>
			</div>
			<!-- 步骤二 -->
			<div v-if="active==2" class="stepTwo">
				<div class="flex-container-up ">
					<div class="flex-item-up" style="padding: 20px 40px;">
						<div style="padding-bottom: 40px;">
							<div>
								<div class="project_Name_box" >
									<span class="stepTowlabel">项目名称：</span>
									<a>{{ruleForm.name}}</a>
								</div>
								<div class="downLoadModel" >
									<span class="stepTowlabel">人员模板：</span>
									<a :href="url+'/zhongfy/download'" class="greenBtn">
										<i class="zb zb-excel"></i>
										下 载 模 板
									</a>
								</div>
								<div class="m-t-15">
									<div class="fl">
										<span class="stepTowlabel">上传数据：</span>
									</div>
									<div class="fl">
										<el-upload class='image-uploader' ref="upload" :multiple='false' list-type='text' :show-file-list='true'
										 :before-upload="beforePhoneUpload" :drag='true' action='' :limit="1" :on-exceed="handleExceed" :http-request="uploadFile">
											<i class="zb zb-huaban fl" style="font-size: 110px;margin:40px"></i>
											<div class="el-upload__text fl " style="padding-top: 50px;padding-left: 10px;">
												<p><em>点击上传</em>,或将填好数据的Excel文件拖拽到虚线框内</p>
												<p>仅支持上传 .xls .xlsx 扩展名的Excel文件</p>
												<p>文件中不可有外部引用的数据，不能含有公式</p>
												<p style="color:#D0121B;">上传数据前请再次核对是否存在人员信息重复，避免造成资金损失！</p>
											</div>
										</el-upload>
										<!-- <a class="button BatchUploadBtn animated swing" @click="submitUpload">解析表格</a> -->
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div style="height: 50px;padding: 40px 0 0 120px;">
					<span class="resetBtn" @click="back">&lt; 项目信息</span> 
				</div>
			</div> 
			<div v-if="active==3" class="stepThree">
							<div class="project_Name_box" >
								<span class="stepTowlabel">项目名称：</span>
								<a>{{ruleForm.name}}</a>
							</div>
							<div class="downLoadModel">
								<span class="stepTowlabel">人员模板：</span>
								<a :href="url+'/zhongfy/download'" class="greenBtn">
									<i class="zb zb-excel"></i>
									下 载 模 板
								</a>
								<a class="blueBtn" style="margin-left: 200px;cursor: pointer;" @click="anewImportBtn">
									<i class="zb zb-shangchuan"></i>
									重新导表
								</a>
							</div>
							<div v-if="maskProgressShow" style="width: 300px;position: fixed;left: 50%;top: 50%;margin-left: -150px;z-index: 9999;">
								<el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
							</div>
							<div class="tableBox m-t-10">
								<div class="titleBox">
									<!-- 正则 -->
									<ul class="tabBtn fl" v-if="regDataShow == false">
										<li class="tabBtn-all tanBtnActive font-Tahoma" @click="allListBtn">共导入数据 {{allNumber}}条</li>
										<li class="tabBtn-error " @click="errorListBtn">
											格式有误数据
											<span class="errorNumberColor font-Tahoma" style="color:#D0121B">{{errorNumber}}</span>
											条
										</li>
									</ul>
									<!-- 三要素 -->
									<ul class="tabBtn fl" v-if="regDataShow == true">
										<li class="tabBtn-three-all tanBtnActive font-Tahoma" @click="allThreeListBtn">共导入数据 {{total}}条</li>
										<li class="tabBtn-three-error " @click="errorThreeListBtn">
											问题数据
											<span class="errorNumberColor font-Tahoma" style="color:#D0121B">{{threeVerifyerrorNumber}}</span>
											条
										</li>
									</ul>
									<div class="fr regHint">
										<i class="zb zb-info" style=""></i>
										<span v-if="regDataShow == false">为确保顺利发放，系统检查数据格式后，会通过三要素验证真实性</span>
										<span v-if="regDataShow == true">错误信息双击即可修改。</span>
										<!-- <span>为确保顺利发放，系统检查数据格式后，会通过三要素验证真实性</span> -->
									</div>
								</div>

								<!-- 正则 -->
								<div v-if=" regDataShow == false ">
									<template v-if="showTableExchange">
										<el-table :data="allData.slice((currentPage-1)*pagesizeManual,currentPage*pagesizeManual)" stripe style="width: 100%">
											<el-table-column label="格式" width="100px">
												<template v-slot="scope">
													<span v-if="scope.row.is_correct =='1' ">
														<img src="../assets/img/zhengzeOK.svg" class="formatImg" alt="" width="20px">
													</span>
													<span class="regUnusually" v-if="scope.row.is_correct =='0' " >异常</span>
												</template>
											</el-table-column>
											<el-table-column label="姓名" width="100px">
												<template slot-scope="{row,$index}">
													<span class="people">{{ row.name}}</span>
												</template>
											</el-table-column>
											<el-table-column label="身份证号" width="180px">
												<template slot-scope="{row,$index}">
													<span class="cardId font-Tahoma">{{ row.identity | id_blank}}</span>
												</template>
											</el-table-column>
											<el-table-column prop="tel" label="手机号" width="120px">
												<template slot-scope="{row,$index}">
													<span class="cardId font-Tahoma">{{ row.tel | vf_mobile}}</span>
												</template>
											</el-table-column>
											<el-table-column label="银行卡号" width="180px">
												<template slot-scope="{row,$index}">
													<span class="bankno font-Tahoma">{{row.bank_card | sub_blank }}</span>
												</template>
											</el-table-column>
											<el-table-column prop="bank_name" label="开户银行" :show-overflow-tooltip="true"></el-table-column>
											<el-table-column prop="open_bank" label="支行" :show-overflow-tooltip="true"></el-table-column>
											<el-table-column label="任务金额" align="right" width="100px" :show-overflow-tooltip="true">
												<template slot-scope="{row,$index}">
													<span class="font-consolas">{{row.money | filterNumber}}</span>
												</template>
											</el-table-column>
											<el-table-column label="备注" align="center"  fixed="right">
												<template v-slot="scope">
													<span style="color: #D0121B;">{{scope.row.reminder}}</span>
												</template>
											</el-table-column>
										</el-table>
										<!-- 分页 -->
										<div class="block regPagination">
											<div class="yaosuVerify fl">
												<span class="resetBtn m-r-20" @click="back"> &lt; 项目信息</span> 
												<span class="btnOK" @click="orderOkBtn">订单要素验证></span>
											</div>
											<el-pagination @current-change="currentChange" background layout="prev, pager, next" :total="allNumber">
											</el-pagination>
										</div>
									</template>
									<template v-if="showTableExchange==false">
										<el-table :data="errorData.slice((errorPage-1)*pagesizeErrorManual,errorPage*pagesizeErrorManual)" stripe
										 style="width: 100%">
											<el-table-column label="格式" width="100px">
												<template v-slot="scope">
													<span style="color: #FFFFFF;background-color: #D0121B;padding: 5px;">异常</span>
												</template>
											</el-table-column>
											<el-table-column label="姓名" width="100px">
												<template slot-scope="{row,$index}">
													<span class="people">{{ row.name}}</span>
												</template>
											</el-table-column>
											<el-table-column prop="identity" label="身份证号" width="180px">
												<template slot-scope="{row,$index}">
													<span class="cardId font-Tahoma">{{ row.identity | id_blank }}</span>
												</template>
											</el-table-column>
											<el-table-column prop="tel" label="手机号" width="120px">
												<template slot-scope="{row,$index}">
													<span class="cardId font-Tahoma">{{ row.tel | vf_mobile}}</span>
												</template>
											</el-table-column>
											<el-table-column label="银行卡号" width="180px">
												<template slot-scope="{row,$index}">
													<span class="bankno font-Tahoma">{{row.bank_card | sub_blank }}</span>
												</template>
											</el-table-column>
											<el-table-column prop="bank_name" label="开户银行" :show-overflow-tooltip="true"></el-table-column>
											<el-table-column prop="open_bank" label="支行" :show-overflow-tooltip="true"></el-table-column>
											<el-table-column prop="money" label="任务金额" align="right" width="100px" :show-overflow-tooltip="true">
												<template slot-scope="{row,$index}">
													<span class="font-consolas">{{row.money | filterNumber}}</span>
												</template>
											</el-table-column>
											<el-table-column label="备注" align="center" fixed="right">
												<template v-slot="scope">
													<span style="color: #D0121B;">{{scope.row.reminder}}</span>
												</template>
											</el-table-column>
										</el-table>
										<!-- 分页 -->
										<div class="block regPagination">
											<div class="yaosuVerify fl">
												<span class="resetBtn m-r-20" @click="back" >
													&lt; 项目信息</span>
											</div>
											<el-pagination @current-change="errorListChange" background layout="prev, pager, next" :total="errorNumber">
											</el-pagination>
										</div>
									</template>
								</div>
								<!-- 三要素 -->
								
								<div v-if="regDataShow == true">
									<template v-if="showTableExchange">
										<el-table :data="threeVerifyAllList.slice((pageNum-1)*pageSizeNow,pageNum*pageSizeNow)" @cell-dblclick="dblChange" stripe style="width: 100%">
											<el-table-column label="格式" width="80px">
												<template v-slot="scope">
													<img src="../assets/img/zhengzeOK.svg" class="formatImg" alt="" width="20px">
												</template>
											</el-table-column>
											<el-table-column prop="name" label="姓名" width="100px">
												<template v-slot="scope">
													<span class="people " v-if="scope.row.cellon == true && scope.row.is_correct !='1' " style="color:#D0121B">{{ scope.row.name}}</span>
													<span class="people " v-if="scope.row.cellon == true && scope.row.is_correct =='1' ">{{ scope.row.name}}</span>
													<input class="threeExChangeInput" type="text" 
													 style="width: 80px;" v-if="scope.row.cellon == false " v-model="scope.row.name">
												</template>
											</el-table-column>
											<el-table-column prop="identity" label="身份证号"  width="180px">
												<template v-slot="scope">
													<span class="cardId font-Tahoma" v-if="scope.row.cellon == true && scope.row.is_correct !='1' " style="color:#D0121B">{{ scope.row.identity | id_blank }}</span>
													<span class="cardId font-Tahoma" v-if="scope.row.cellon == true && scope.row.is_correct =='1' ">{{ scope.row.identity | id_blank }}</span>
													<input type="text" v-if="scope.row.cellon == false "  v-model="scope.row.identity">
												</template>
											</el-table-column>
											<el-table-column prop="bank_card" label="银行卡号" width="180px">
												<template v-slot="scope">
													<span class="bankno font-Tahoma" v-if="scope.row.cellon == true && scope.row.is_correct !='1' " style="color:#D0121B">{{ scope.row.bank_card | sub_blank }}</span>
													<span class="bankno font-Tahoma" v-if="scope.row.cellon == true && scope.row.is_correct =='1' ">{{ scope.row.bank_card | sub_blank }}</span>
													<input type="text" v-if="scope.row.cellon == false "  v-model="scope.row.bank_card">
												</template>
											</el-table-column>
											<el-table-column prop="bank_name" label="开户银行" :show-overflow-tooltip="true" >
												<template v-slot="scope">
													<span v-if="scope.row.cellon == true ">{{ scope.row.bank_name }}</span>
													<input type="text"  style="width: 120px;" v-if="scope.row.cellon == false "  v-model="scope.row.bank_name">
												</template>
											</el-table-column>
											<el-table-column prop="open_bank" label="支行" :show-overflow-tooltip="true">
												<template v-slot="scope">
													<span v-if="scope.row.cellon == true ">{{ scope.row.open_bank }}</span>
													<input type="text" v-if="scope.row.cellon == false "  v-model="scope.row.open_bank">
												</template>
											</el-table-column>
											<el-table-column prop="tel" label="手机号" align="center" width="120px">
												<template v-slot="scope">
													<span class="font-Tahoma" v-if="scope.row.cellon == true ">{{ scope.row.tel | vf_mobile}}</span>
													<input type="text" style="width: 100px;" v-if="scope.row.cellon == false "  v-model="scope.row.tel">
												</template>
											</el-table-column>
											<el-table-column prop="money" label="任务金额" align="right" width="100px">
												<template v-slot="scope">
													<span class="font-consolas" v-if="scope.row.cellon == true ">{{scope.row.money | filterNumber}}</span>
													<input type="text" style="width: 80px;"  v-if="scope.row.cellon == false "  v-model="scope.row.money">
												</template>
											</el-table-column>
											<el-table-column label="三要素验证" fixed="right" align="center" width="140px">
												<template v-slot="scope">
													<span v-if="scope.row.is_correct =='1' " style="color:#28c76f;">数据通过</span>
													<!-- <span class="regUnusually" v-if="scope.row.is_correct !='1' ">验证不通过</span> -->
													<span class="cursor-pointer" v-if="scope.row.is_correct !='1' && scope.row.cellon == true" @click="redactBtn(scope.row)">
														<i class="zb zb-alert" style="color: #ea5455; position:relative;top:1px;"></i>
													</span>
													
													<el-link type="primary" v-if="scope.row.is_correct !='1' && scope.row.cellon == true" style="font-size: 12px;" @click="redactBtn(scope.row)">
														<i class="zb zb-edit" style="color: #2C4198;"></i>
														编辑 
													</el-link>
													<span class="miniBlueBtn" v-if="scope.row.is_correct !='1' && scope.row.cellon == false" @click="singleThree(scope.row)">保存</span>
													<span class="cancelBlueBtn" v-if="scope.row.is_correct !='1' && scope.row.cellon == false" @click="tableInpueBlur(scope.row)">取消</span>
													<!-- <el-link type="primary" v-if="scope.row.is_correct !='1' && scope.row.cellon == false" style="font-size: 13px;" @click="singleThree(scope.row)"> 保存 </el-link> -->
													<!-- <el-link type="danger" v-if="scope.row.is_correct !='1' && scope.row.cellon == false" style="font-size: 13px;" @click="tableInpueBlur(scope.row)"> 取消 </el-link> -->
												</template>
											</el-table-column>
										</el-table>
										<!-- 分页 -->
										<div class="block regPagination">
											<div class="yaosuVerify fl">
												<span class="resetBtn m-r-20" @click="back" >
													&lt; 项目信息</span> <a class="btnOK" @click="calculateMoney">计算项目金额 ></a>
											</div>
											<el-pagination @current-change="threeChange" background layout="prev, pager, next" :total="total">
											</el-pagination>
										</div>
									</template>
									<!-- @cell-dblclick="dblChange" -->
									<template v-if="showTableExchange==false">
										<el-table :data="threeVerifyerrorList" @cell-dblclick="dblChange" stripe style="width: 100%">
											<el-table-column label="格式" width="80px">
												<template v-slot="scope">
													<img src="../assets/img/zhengzeOK.svg" class="formatImg" alt="" width="20px">
												</template>
											</el-table-column>
											<el-table-column prop="name" label="姓名" width="100px">
												<template v-slot="scope">
													<span class="people" v-if="scope.row.cellon == true && scope.row.is_correct !='1' " style="color:#D0121B">{{ scope.row.name}}</span>
													<span class="people" v-if="scope.row.cellon == true && scope.row.is_correct =='1' ">{{ scope.row.name}}</span>
													<input type="text" style="width: 80px;" v-if="scope.row.cellon == false " 
													 v-model="scope.row.name">
												</template>
											</el-table-column>
											<el-table-column prop="identity" label="身份证号" width="180px">
												<template v-slot="scope">
													<span class="cardId font-Tahoma" v-if="scope.row.cellon == true && scope.row.is_correct !='1' " style="color:#D0121B">{{ scope.row.identity | id_blank }}</span>
													<span class="cardId font-Tahoma" v-if="scope.row.cellon == true && scope.row.is_correct =='1' ">{{ scope.row.identity | id_blank }}</span>
													<input type="text" v-if="scope.row.cellon == false "  v-model="scope.row.identity">
												</template>
											</el-table-column>
											<el-table-column prop="bank_card" label="银行卡号" width="180px">
												<template v-slot="scope">
													<span class="bankno font-Tahoma" v-if="scope.row.cellon == true && scope.row.is_correct !='1' " style="color:#D0121B">{{ scope.row.bank_card | sub_blank}}</span>
													<span class="bankno font-Tahoma" v-if="scope.row.cellon == true && scope.row.is_correct =='1' ">{{ scope.row.bank_card | sub_blank }}</span>
													<input type="text" v-if="scope.row.cellon == false "  v-model="scope.row.bank_card">
												</template>
											</el-table-column>
											<el-table-column prop="bank_name" label="开户银行" :show-overflow-tooltip="true">
												<template v-slot="scope">
													<span v-if="scope.row.cellon == true ">{{ scope.row.bank_name }}</span>
													<input type="text" v-if="scope.row.cellon == false " style="width: 120px;" v-model="scope.row.bank_name">
												</template>
											</el-table-column>
											<el-table-column prop="open_bank" label="支行" :show-overflow-tooltip="true">
												<template v-slot="scope">
													<span v-if="scope.row.cellon == true ">{{ scope.row.open_bank }}</span>
													<input type="text" v-if="scope.row.cellon == false "  v-model="scope.row.open_bank">
												</template>
											</el-table-column>
											<el-table-column prop="tel" label="手机号" align="center" width="120px">
												<template v-slot="scope">
													<span class="font-Tahoma" v-if="scope.row.cellon == true ">{{ scope.row.tel }}</span>
													<input type="text" style="width: 100px;" v-if="scope.row.cellon == false "  v-model="scope.row.tel">
												</template>
											</el-table-column>
											<el-table-column prop="money" label="任务金额" align="right" width="100px">
												<template v-slot="scope">
													<span class="font-consolas" v-if="scope.row.cellon == true ">{{scope.row.money | filterNumber}}</span>
													<input type="text" style="width: 80px;"  v-if="scope.row.cellon == false "  v-model="scope.row.money">
												</template>
											</el-table-column>
											<el-table-column label="三要素验证" fixed="right" align="center" width="140px">
												<template v-slot="scope">
													<!-- <span class="regUnusually" v-if="scope.row.is_correct !='1' ">验证不通过</span> -->
													
													<span class="cursor-pointer" v-if="scope.row.cellon == true"  @click="redactBtn(scope.row)">
														<i class="zb zb-alert" style="color: #ea5455; position:relative;top:1px;"></i>
													</span>
													<el-link type="primary" v-if="scope.row.cellon == true" style="font-size: 12px;" @click="redactBtn(scope.row)">
														<i class="zb zb-edit" style="color: #2C4198;"></i>
														编辑 
													</el-link>
													<span class="miniBlueBtn" v-if="scope.row.is_correct !='1' && scope.row.cellon == false" @click="singleThree(scope.row)">保存</span>
													<span class="cancelBlueBtn" v-if="scope.row.is_correct !='1' && scope.row.cellon == false" @click="tableInpueBlur(scope.row)">取消</span>
													<!-- <el-link type="primary" v-if="scope.row.cellon == false" style="font-size: 13px;" @click="singleThree(scope.row)"> 保存 </el-link>
													<el-link type="danger" v-if="scope.row.cellon == false" style="font-size: 13px;" @click="tableInpueBlur(scope.row)"> 取消 </el-link> -->
												</template>
											</el-table-column>
										</el-table>
									</template>
								</div>
							</div>
				</div>
			</div>
			<!-- 有错误人员提示 -->
			<el-dialog title="提示" :visible.sync="errorPeopleHint" :width="dialogiWidth" :close-on-click-modal="false">
				<p class="errorDialogContent">表格中存在<span @click="lookErrorData"> 错误数据 </span>请修改并重新导入</p>
				<div slot="footer" class="dialog-footer">
					<span class="lookErrorBtn" @click="lookErrorData">查看错误数据</span>
				</div>
			</el-dialog>
			<!-- 三要素错误人员提示 -->
			<el-dialog title="提示" :visible.sync="threeErrorHint" :width="dialogiWidth" :close-on-click-modal="false">
				<p class="errorDialogContent">表格中存在<span @click="lookErrorData"> 要素错误数据 </span>请修改并重新导入</p>
				<div slot="footer" class="dialog-footer">
					<span class="lookErrorBtn" @click="lookErrorData">查看错误数据</span>
				</div>
			</el-dialog>

		</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	import {
		mainfun
	} from '../assets/js/main.js';
	import {
		publicData
	} from '../assets/js/data.js';
	export default {
		name: 'projectNew',
		data() {
			return {
				maskProgressShow:false, //进度条
				percentage:0, //三要素进度条
				userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				url: common.url,
				active: 1,
				provinceArr: [], //省份
				cityArr: [], //城市
				regDataShow: false, //正则数据   跟三要素
				dialogiWidth: '30%', //宽度 弹框宽度切换 '30%'电脑屏幕  ‘80’ 手机屏幕
				allNumber: 0, //全部数据 个数
				errorNumber: 0, // 错误数据 个数
				/*任务模板*/ 
				taskTypeArr: [], //任务类型数组
				modelArr:[],//任务模板数组
				activeModel:'', //选择的模板
				modelShow:false,  //模板选择
				lastAddress:{}, //上一次地址
				
				basicInfoID: '', //基本信息id
				excel_id: '',
				ruleForm: {
					name: '',
					taskType: '',
					province: '',
					city: '',
					dateAll: '',
					startDate: '',
					endDate: '',
					address: '',
					money: '',
					remark: ''
				},
				rules: {
					name: [{
							required: true,message: '请输入任务名称',trigger: 'change'
						},
						{
							min: 5,	max: 30,message: '长度在 5 到 30 个字符',trigger: 'change'
						}
					],
					taskType: [{
						required: true,message: '请选择任务类型',trigger: 'change'
					}],
					province: [{
						required: true,message: '请选择省',trigger: 'change'
					}],
					city: [{
						required: true,message: '请选择市',	trigger: 'change'
					}],
					dateAll: [{
						required: true,message: '请选择项目时间',trigger: 'change'
					}],
					money: [{
						required: true,message: '请输入任务预算',trigger: 'change'
					}],
					remark: [{
							required: true,message: '请填写任务描述',trigger: 'change'
						},
						{
							min: 20,message: '长度不能少于 20 个字符',trigger: 'change'
						}
					]
				},
				allData: [], //所以数据
				errorData: [], //错误数据
				showDataImportSwitch: true, //上传表格跟表格切换
				showTableExchange: true, //表格切换
				errorPeopleHint: false, //错误人员提示框
				screenWidth: document.documentElement.clientWidth,
				// 全部数据集合分页
				currentPage: 1, //初始页
				currentErrorPage: 1, //全部数据初始页
				pagesizeManual: 10, //每页条数
				// 错误数据几个分页
				pagesizeError: 1, //初始页
				errorPage: 1, //问题数据初始页
				pagesizeErrorManual: 10, //每页条数
				/* 三要素返回的数据 */
				threeVerifyAllList: [], //三要素返回订单全部的
				threeVerifyerrorList: [], //三要素返回订单错误的
				total: 0, //总数
				threeVerifyerrorNumber: 0, //三要素返回的错误条数
				pageNum: 1, //当前页
				// pageSize: [10, 20, 50, 100], //每页展示条数
				pageSizeNow: 10, //当前每页多少行
				tempStorage: {}, //点击编辑时候临时的存储
				threeErrorHint: false, //三要素错误提示
				submit_id: '', //要素验证返回的id
				
				

			}
		},
		mounted() {
			this.startResult();
			this.keyEventLogin(); //回车事件
			// 手机屏幕
			if (this.screenWidth <= 768) {
				this.dialogiWidth = '80%';
			};
			window.onresize = () => {
				this.screenWidth = document.documentElement.clientWidth;
				if (this.screenWidth <= 768) {
					this.dialogiWidth = '80%';
				}
			};
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //判断是否登录
					window.location = 'login.html';
					return;
				}
				if (sessionStorage.getItem("basicInfoID")) { //判断是否输入过基本信息
					this.active = 2;
					this.basicInfoID = JSON.parse(sessionStorage.getItem("basicInfoID"));
					// this.ruleForm = JSON.parse(sessionStorage.getItem("ruleForm"));
					this.ruleForm = JSON.parse(decodeURIComponent(window.atob(sessionStorage.getItem("ruleForm"))));
				}
				this.verifyActive(); // 步骤条判断
				this.getDistrict(); //获取省份
				this.getProjectType(); //  任务类型模板
			},
			
			// 任务类型模板
			getProjectType(){
				this.$http.post(this.url + '/zhongfy/company/ProjectType').then((res) => {
					if (res.data.code == '200' || res.data.msg == '成功') {
						 this.taskTypeArr = res.data.data.type;
						 this.lastAddress = res.data.data.address;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					}
				}, (res) => {
					this.$message.error('网络错误');
				})
			},
			
			taskTypeChange(val){ //  任务类型监听
				this.activeModel = '';
				this.ruleForm.name = '';
				this.ruleForm.remark = '';
				for(let i = 0 ; i < this.taskTypeArr.length ; i++){
					if( val == this.taskTypeArr[i].project_cate ){
						if( this.taskTypeArr[i].temp != undefined){
							this.modelArr = [...this.taskTypeArr[i].temp];
							this.modelShow = true;
						}else{
							this.modelShow = false;
						}
					}
				}
			},
			
			modelChange(val){  //模板监听
				let resdata = JSON.parse(JSON.stringify( this.modelArr[val] ));
				this.ruleForm.name = resdata.project_name;
				this.ruleForm.remark = resdata.project_desc;
			},
			
			lastAddressBtn(){ // 点击上一次地址
				this.ruleForm.province = this.lastAddress.district;
				this.ruleForm.city = this.lastAddress.city;
			},
			
			getDistrict() { //省份
				this.$http.post(this.url + '/zhongfy/company/getDistrict').then((res) => {
					if (res.data.code == '200' || res.data.msg == '成功') {
						this.provinceArr = res.data.data
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					}
				}, (res) => {
					this.$message.error('网络错误');
				})
			},
			back() { //返回上一步
				// sessionStorage.removeItem('basicInfoID'); //删除本地存储的基本信息id
				this.active = 1;
				this.regDataShow = false ;  //显示正则	
				this.showTableExchange = true ;	//显示正则 全部数据
				this.verifyActive(); //步骤条判断
				this.percentage = 0; //进度条0
			},
			dateChange(val) { //时间监听
				if(!val){
					return;
				}
				this.ruleForm.startDate = val[0];
				this.ruleForm.endDate = val[1];
			},
			keyEventLogin: function() { //回车获取市
				var _this = this;
				document.onkeydown = function(event) {
					if (event.keyCode == '13') {
						if (_this.ruleForm.province == '' || _this.ruleForm.city != '') { //省为空返回  市不为空返回
							return;
						} else {
							_this.provinceClick(_this); //调取市接口
						}
					}
				}
			},
			provinceClick(id) { //获取市
				// ruleForm.province
				let provinceId = id;
				if (isNaN(provinceId)) { // 判断id是不是个数  不是的就用省查出id
					for (let i = 0; i < this.provinceArr.length; i++) {
						if (this.ruleForm.province == this.provinceArr[i].name) {
							provinceId = this.provinceArr[i].id
						}
					}
				}
				let fn = new FormData();
				fn.append('id', provinceId); //文件
				this.$http.post(this.url + '/zhongfy/company/getCity', fn).then((res) => {
					if (res.data.msg == '成功' || res.data.code == '200') {
						this.cityArr = res.data.data;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error('获取城市失败！');
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			provinceChange(val) { //省份监听事件
				this.cityArr = []; //市数组清空
				this.ruleForm.city = ''; //清空原选定的市
			},
			submitForm(formName) { //基本信息下一步 
				 //今天时间的时间
				var today = new Date();
				today.setTime(today.getTime());
				var cutOffDay = today.getFullYear()+"-" + mainfun.getzf((today.getMonth()+1)) + "-" + mainfun.getzf(today.getDate());
				let startDateMS = new Date(this.ruleForm.startDate).getTime()  //项目开始时间毫秒数
				let cutOffDayMS = new Date(cutOffDay).getTime()//今天时间毫秒数
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if(cutOffDayMS < startDateMS){
							this.$alert('<strong>项目开始日期不能大于今天!</strong>', '提示', {
							    dangerouslyUseHTMLString: true
							});
							return;
						}
						let fn = new FormData();
						fn.append('u_id', this.userInfo.id); //
						fn.append('name', this.ruleForm.name); //
						fn.append('type', this.ruleForm.taskType); //
						fn.append('start_time', this.ruleForm.startDate); //
						fn.append('end_time', this.ruleForm.endDate); //
						fn.append('district', this.ruleForm.province); //
						fn.append('city', this.ruleForm.city); //
						fn.append('content', this.ruleForm.remark); //
						fn.append('address', this.ruleForm.address); //
						this.$http.post(this.url + '/zhongfy/company/AddProject', fn).then((res) => {
							if (res.data.code == '200' || res.data.msg == '添加成功') {
								this.basicInfoID = res.data.data.id
								sessionStorage.setItem("basicInfoID", JSON.stringify(this.basicInfoID));
								sessionStorage.setItem("ruleForm",window.btoa(window.encodeURIComponent(JSON.stringify(this.ruleForm))));
								this.active = 2;
								this.verifyActive(); //步骤条判断
							} else if (res.data.code == '8886') { //code   8886  登录过期
								sessionStorage.clear();
								this.$alert('登录已过期，请重新登录 !', '提示', {
									confirmButtonText: '确定',
									callback: action => {
										window.location = 'login.html';
									}
								});
								return;
							} else {
								this.$message.error(res.data.msg);
							}
						}, (res) => {
							this.$message.error('网络错误');
						})
					} else {
						this.$message.error('请完善基本信息！');
						return false;
					}
				});
			},

			// 上传文件之前的钩子
			beforePhoneUpload(file) {
				var fileNameArr = file.name.split('.');
				var length = fileNameArr.length;
				if (fileNameArr[length - 1] != 'xlsx' && fileNameArr[length - 1] != 'xls') {
					this.$message.error('请上传“.xls”“.xlsx”后缀的文件。');
					return false;
				}
				let isLt2M = file.size < 5 * 1024 * 1024;
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 5MB!');
					return false;
				}
			},
			// 上传文件个数超过定义的数量
			handleExceed(files, fileList) {
				// this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
				this.$alert('<strong>当前限制选择 1 个文件，请删除后继续上传</strong>', '提示', {
				    dangerouslyUseHTMLString: true
				});
			},
			uploadFile(item) {
				let fileObj = item.file;
				let fn = new FormData();
				fn.append('u_id', this.userInfo.id); //文件
				fn.append('file', fileObj); //文件
				fn.append('id', this.basicInfoID); //基本信息id
				this.$http.post(this.url + '/zhongfy/company/queryLoad', fn)
					.then((res) => {
						console.log(res);
						let data = res.data;
						if (data.code == '200' || data.msg == '成功') {
							if(data.data.allList == undefined || data.data.errorList == undefined){
								this.$message.error('表格解析错误，请重新下载模板在上传');
								return;
							}
							this.allNumber = Number(data.data.allList.length) + Number(data.data.errorList.length);
							this.errorNumber = data.data.errorList.length;
							if (this.errorNumber <= 0) {
								setTimeout(() => {
									$('.tabBtn-all').addClass('tanBtnActiveBorder');
									$('.tabBtn-error').addClass('display-n');
								}, 10)
							} else {
								setTimeout(() => {
									$('.tabBtn-all').removeClass('tanBtnActiveBorder');
									$('.tabBtn-error').removeClass('display-n');
									// this.errorListBtn(); //执行错误显示
								}, 10)
							}
							let allData = data.data.allList;
							this.errorData = data.data.errorList;
							this.allData = this.errorData.concat(allData);
							this.excel_id = data.data.excel_id;
							this.$refs['upload'].clearFiles(); //清除上传完的文件
							this.active = 3;
							this.verifyActive(); //步骤条判断
						} else {
							this.$alert('<strong>'+data.msg+'</strong>', '提示', {
							    dangerouslyUseHTMLString: true
							});
							return;
						}
					}, (err) => {
						this.$message.error('网络错误');
						return;
					});
			},
			allListBtn() { //点击全部数据  正则
				$('.tabBtn-all').addClass('tanBtnActive');
				$('.tabBtn-error').removeClass('errorTanBtnActive');
				$('.errorNumberColor').css({
					color: '#D0121B'
				});
				this.showTableExchange = true; //表格显示正确的
			},
			errorListBtn() { //点击错误数据 正则
				$('.tabBtn-error').addClass('errorTanBtnActive');
				$('.tabBtn-all').removeClass('tanBtnActive');
				$('.errorNumberColor').css({
					color: '#FFFFFF'
				});
				this.showTableExchange = false; //表格显示错误的
			},

			allThreeListBtn() { //三要素
				$('.tabBtn-three-all').addClass('tanBtnActive');
				$('.tabBtn-three-error').removeClass('errorTanBtnActive');
				$('.errorNumberColor').css({
					color: '#D0121B'
				});
				this.showTableExchange = true; //表格显示正确的
			},

			errorThreeListBtn() { //三要素
				$('.tabBtn-three-error').addClass('errorTanBtnActive');
				$('.tabBtn-three-all').removeClass('tanBtnActive');
				$('.errorNumberColor').css({
					color: '#FFFFFF'
				});
				this.showTableExchange = false; //表格显示错误的
			},

			orderOkBtn() { //下一步订单要素验证
				if (this.errorNumber > '0') {
					this.errorPeopleHint = true;
					return;
				} else {
					publicData.isShowLoading = false;
					const loading = this.$loading({
					          lock: true,
					          text: 'Loading',
					          spinner: 'el-icon-loading',
					          background: 'rgba(0, 0, 0, 0.4)'
					        });
					let fn = new FormData();
					fn.append('excel_id', this.excel_id); //excel返回的ID
					fn.append('id', this.basicInfoID); //基本信息id
					this.$http.post(this.url + '/zhongfy/company/AddOrder', fn).then((res) => {
						let data = res.data;
						if (data.code == '200' || data.msg == '成功') {
							this.percentage = 100;
							if(this.percentage == 100){
								loading.close();  //关闭loading
								publicData.isShowLoading = true;
								setTimeout(()=>{
									this.maskProgressShow = false;
									this.regDataShow = true; //三要素数据显示
									this.allThreeListBtn(); //执行全部数据显示
									this.threeVerifyerrorNumber = data.data.errorList.length;
									this.total = Number(data.data.allList.length) + Number(data.data.errorList.length);
									if (this.threeVerifyerrorNumber <= 0) {
										setTimeout(() => {
											$('.tabBtn-three-all').addClass('tanBtnActiveBorder');
											$('.tabBtn-three-error').addClass('display-n');
										}, 10)
									} else {
										setTimeout(() => {
											$('.tabBtn-three-all').removeClass('tanBtnActiveBorder');
											$('.tabBtn-three-error').removeClass('display-n');
										}, 10)
									}
									let allList = data.data.allList;
									let errorList = data.data.errorList;
									this.submit_id = data.data.submit_id;
									for (let i = 0; i < allList.length; i++) {
										let key = 'cellon';
										let value = true;
										allList[i][key] = value;
									}
									for (let i = 0; i < errorList.length; i++) {
										let key = 'cellon';
										let value = true;
										errorList[i][key] = value;
									}
									this.threeVerifyerrorList = errorList;
									this.threeVerifyAllList = errorList.concat(allList);
								},500);
							}
							
						} else if (data.code == '8886') { //code   8886  登录过期
							sessionStorage.clear();
							this.$alert('登录已过期，请重新登录 !', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									window.location = 'login.html';
								}
							});
							return;
						} else {
							// this.$message.error(data.msg);
							this.$alert('<strong>'+data.msg+'</strong>', '提示', {
							    dangerouslyUseHTMLString: true
							});
							loading.close();  //关闭loading
							publicData.isShowLoading = true;
							this.maskProgressShow = false;   //停止滚动条请求接口
							return;
						}
					}, (err) => {
						this.$message.error('网络错误');
						publicData.isShowLoading = true;
						this.maskProgressShow = false;  //停止滚动条请求接口
						loading.close();  //关闭loading
						return;
					});
					this.maskProgressShow = true;  //启动滚动条
					setTimeout( ()=>{
						this.verifyProgress(); //三要素进度滚动条
					},50);
				}
			},
			verifyProgress(){  //获取三要素进度滚动条
				if( !this.maskProgressShow ){
					return;
				}
				let formData = new FormData();
				formData.append('excel_id', this.excel_id); //excel返回的ID
				this.$http.post(this.url + '/zhongfy/company/verifyProgress', formData).then((res) => {
					let data = res.data;
					if (data.code == '200' || data.msg == '成功') {
						this.percentage = parseInt( data.data.percentage);
						if( this.percentage >= 99 ){
							return;
						}
						this.verifyProgress(); //三要素进度
					} else if (data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						// this.$message.error(data.msg);
						this.$alert('<strong>'+data.msg+'</strong>', '提示', {
						    dangerouslyUseHTMLString: true
						});
						publicData.isShowLoading = true;
						return;
					}
				}, (err) => {
					this.$message.error('网络错误');
					publicData.isShowLoading = true;
					return;
				});
			},
			calculateMoney() { //计算项目金额
				if (this.threeVerifyerrorNumber > '0') {
					this.threeErrorHint = true;
					return;
				} else {
					let fn = new FormData();
					fn.append('id', this.basicInfoID); //基本信息id
					fn.append('submit_id', this.submit_id); //三要素id
					this.$http.post(this.url + '/zhongfy/company/SubmitOrder', fn).then((res) => {
						let data = res.data;
						console.log(res);
						if (data.code == '200' || data.msg == '成功') {
							sessionStorage.removeItem('basicInfoID'); //删除项目基本信息id
							sessionStorage.removeItem('submit_id'); //删除项目三要素id
							sessionStorage.removeItem('ruleForm'); //删除项目基本信息
							this.$router.push('/projectNewDetail');
							this.$router.push({
								path: '/projectNewDetail',
								query: {
									id: data.data.id
								}
							})
						} else if (data.code == '8886') { //code   8886  登录过期
							sessionStorage.clear();
							this.$alert('登录已过期，请重新登录 !', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									window.location = 'login.html';
								}
							});
							return;
						} else {
							// this.$message.error(data.msg);
							this.$alert('<strong>'+data.msg+'</strong>', '提示', {
							    dangerouslyUseHTMLString: true
							});
							return;
						}
					}, (err) => {
						this.$message.error('网络错误');
						return;
					});
				}
			},
			dblChange(row, column, cell, event) { //点击修改监听
				if(row.is_correct=='1'){
					return;
				}
				for (let i = 0; i < this.threeVerifyerrorList.length; i++) {
					this.threeVerifyerrorList[i].cellon = true;
				}
				for (let i = 0; i < this.threeVerifyAllList.length; i++) {
					this.threeVerifyAllList[i].cellon = true;
				}
				row.cellon = false;
				this.tempStorage = JSON.parse(JSON.stringify(row));
			},
			tableInpueBlur(row) { //取消
				// 取消把原来的数据赋值回去
				row.name = this.tempStorage.name;
				row.bank_card = this.tempStorage.bank_card;
				row.bank_name = this.tempStorage.bank_name;
				row.identity = this.tempStorage.identity;
				row.money = this.tempStorage.money;
				row.tel = this.tempStorage.tel;
				row.cellon = true;
			},
			redactBtn(row){  //编辑错误三要素
				for (let i = 0; i < this.threeVerifyerrorList.length; i++) {
					this.threeVerifyerrorList[i].cellon = true;
				}
				for (let i = 0; i < this.threeVerifyAllList.length; i++) {
					this.threeVerifyAllList[i].cellon = true;
				}
				this.tempStorage = JSON.parse(JSON.stringify(row)); //临时存储要编辑的数据，
				row.cellon = false;
			},
			singleThree(row){  //单个人保存验证三要素
				let fn = new FormData();
				fn.append('name', row.name); //名字
				fn.append('tel', row.tel); //手机号
				fn.append('identity', row.identity); //身份证
				fn.append('bank_name', row.bank_name); //银行名称
				fn.append('open_bank', row.open_bank); //支行
				fn.append('bank_card', row.bank_card); //银行卡号
				fn.append('money', row.money); //金额
				fn.append('submit_id', this.submit_id); //三要素id
				this.$http.post(this.url + '/zhongfy/company/realNameAuth', fn).then((res) => {
					let data = res.data;
					if (data.code == '200') {
						if(data.data.is_correct == 1) {
							this.$message.success('验证成功！');
							row.cellon = true;
							row.is_correct = '1';
							let threeVerifyerrorList = this.threeVerifyerrorList;
							for(let i = 0 ; i < threeVerifyerrorList.length; i++){
								if( threeVerifyerrorList[i].id == row.id ){
									threeVerifyerrorList.splice([i], 1);
									if(threeVerifyerrorList.length == 0 ){ //如果三要素错误数据没有了
										this.threeVerifyerrorNumber = 0; //三要素错误数据
										$('.tabBtn-three-all').addClass('tanBtnActiveBorder');
										$('.tabBtn-three-error').addClass('display-n');
										this.allThreeListBtn(); //执行正确的数据信息显示
									}else{
										this.threeVerifyerrorNumber = threeVerifyerrorList.length;
									}
								}
							}
						}else{
							this.$message.error('验证不通过！');
							return;
						}	
					} else if (data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(data.msg);
						return;
					}
				}, (err) => {
					this.$message.error('网络错误');
					return;
				});
			},

			lookErrorData() { //查看错误数据
				this.errorPeopleHint = false;
				this.threeErrorHint = false;
				this.errorListBtn();
				this.errorThreeListBtn();
			},
			anewImportBtn() { //重新导入
				this.active = 2;
				this.allNumber = 0;
				this.errorNumber = 0;
				this.allData = []; //正则返回订单全部的
				this.errorData = []; //正则返回订单错误的
				this.threeVerifyAllList = []; //三要素返回订单全部的
				this.threeVerifyerrorList = []; //三要素返回订单错误的
				this.verifyActive(); //步骤条判断
				this.regDataShow = false;
				this.showTableExchange = true;
				this.percentage = 0; //进度条
				this.currentPage = 1;
				this.pagesizeError =1;
				this.pageNum = 1;
			},
			currentChange(pageNow) { //分页监听 (全部数据)
				this.currentPage = pageNow;
			},
			errorListChange(pageNow) { //分页监听 (错误数据)
				this.errorPage = pageNow;
			},
			threeChange(pageNow) { //分页三要素正确 (全部数据)
				this.pageNum = pageNow;
			},
			verifyActive() { // 步骤条判断
				if (this.active == 1) {
					$('.step01').addClass('stepRed');
					$('.step01').removeClass('stepGreen');
					$('.step02').removeClass('stepRed');
					$('.step02').removeClass('stepGreen');
					$('.step03').removeClass('stepRed');
					$('.step03').removeClass('stepGreen');
					$('.hintDian1').removeClass('stepBlack');
					$('.hintDian2').removeClass('stepBlack');
				} else if (this.active == 2) {
					$('.step01').removeClass('stepRed');
					$('.step01').addClass('stepGreen');
					$('.step02').addClass('stepRed');
					$('.step02').removeClass('stepGreen');
					$('.step03').removeClass('stepRed');
					$('.step03').removeClass('stepGreen');
					$('.hintDian1').addClass('stepBlack');
					$('.hintDian2').removeClass('stepBlack');
				} else if (this.active == 3) {
					$('.step01').addClass('stepGreen');
					$('.step02').addClass('stepGreen');
					$('.step03').addClass('stepRed');
					$('.hintDian1').addClass('stepBlack');
					$('.hintDian2').addClass('stepBlack');
				}
			},
			

		},
		filters: {
			
		}
	}
</script>

<style scoped>
	.projectNew {}

	.step_BOX {
		border-bottom: 1px solid #e8e8e8;
		height: 110px;
	}

	.step {
		color: #999999;
	}

	.stepRed {
		color: var(--theme-red);
	}

	.stepGreen {
		color: var(--theme-green);
	}

	.stepBlack {
		color: var(--theme-black);
	}

	.step01 .font_Box {
		width: 30%;
		text-align: right;
	}

	.step02 .font_Box {
		width: 20%;
		text-align: right;
	}

	.step03 .font_Box {
		width: 20%;
		text-align: right;
	}

	.step01 .cont_Box {
		width: 70%;
	}

	.step02 .cont_Box {
		width: 50%;
	}

	.step03 .cont_Box {
		width: 50%;
	}

	.cont_Box>div {
		padding: 10px 0 10px 5px;
	}

	.cont_Box h3 {
		line-height: 36px;
	}

	.cont_Box p {
		font-size: 13px;
	}

	.step .hintDian1,
	.step .hintDian2 {
		width: 30%;
		/* text-align: center; */
		line-height: 90px;
	}

	.hintDian1 span:nth-child(1),
	.hintDian1 span:nth-child(3),
	.hintDian2 span:nth-child(1),
	.hintDian2 span:nth-child(3) {
		font-size: 14px;
	}

	.hintDian1 span:nth-child(2),
	.hintDian2 span:nth-child(2) {
		font-size: 20px;
		position: relative;
		top: 2px;
	}


	/* 步骤一 */

	.fontStepF {
		font-family: 'Impact', sans-serif;
		font-weight: 900;
		font-style: normal;
		margin-right: 5px;
		font-size: 60px;
	}

	.stepOne {
		display: -webkit-flex;
		display: flex;
		-webkit-justify-content: left;
		justify-content: left;

		/* padding: 15px; */
	}

	/* .demo-ruleForm {
		padding-left: 6%;
	} */

	.BatchUploadBtn {
		display: block;
		width: 360px;
		line-height: 40px;
		text-align: center;
		background: var(--theme-btn);
		border-radius: 5px;
		color: #FFFFFF;
		margin: 10px 0;
		margin-top: 50px;
		cursor: pointer;
		transition: all 0.5s;
		-moz-transition: all 0.5s;
		/* Firefox 4 */
		-webkit-transition: all 0.5s;
		/* Safari and Chrome */
		-o-transition: all 0.5s;
		/* Opera */
		box-shadow: 1px 2px 5px var(--theme-purple2);
		-moz-box-shadow: 1px 2px 5px var(--theme-purple2);
		-webkit-box-shadow: 1px 2px 5px var(--theme-purple2);
		opacity: 0.8;
	}

	.BatchUploadBtn:hover {
		opacity: 1;
		background: var(--theme-btn) !important;
	}

	.flex-container-up {
		display: -webkit-flex;
		display: flex;
		-webkit-justify-content: left;
		justify-content: left;

	}

	.flex-item-up {}

	.articleSteps {
		background-color: #FFFFFF;
		border-radius: 5px;
		padding: 20px 0;
		margin-top: 15px;
	}

	.NewOrderContent {
		background-color: #FFFFFF;
		padding: 15px;
		border-radius: 5px;
		margin-top: 15px;
	}

	/* 表格 */
	.tableBox {}

	.tableBox .titleBox {
		height: 50px;
		border-bottom: 1px solid #e8e8e8;
	}

	.tabBtn li {
		float: left;
		padding: 0 20px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
		font-size: 14px;
	}

	.tabBtn-all {
		border: 1px solid #CCCCCC;
		border-right: none;
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
	}

	.tabBtn-error {
		border: 1px solid #CCCCCC;
		border-left: none;
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
	}

	.tabBtn-three-all {
		border: 1px solid #CCCCCC;
		border-right: none;
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
	}

	.tabBtn-three-error {
		border: 1px solid #CCCCCC;
		border-left: none;
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
	}

	.regHint {
		font-size: 14px;
		color: #60686f;
		line-height: 50px;
	}

	.tanBtnActive {
		background-color: var(--zfy-blue) !important;
		border-color: var(--zfy-blue) !important;
		color: #FFFFFF;
	}

	.tanBtnActiveBorder {
		border-right: 1px solid var(--zfy-blue) !important;
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
	}

	.errorTanBtnActive {
		background-color: var(--theme-red) !important;
		border-color: var(--theme-red) !important;
		color: #FFFFFF;
	}

	.reset {
		color: #666666;
		cursor: pointer;
	}

	.reset:hover {
		color: #333333;
		text-decoration: underline;
	}

	.operateBtn li {
		float: left;
		padding: 0 20px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		border: 1px solid #CCCCCC;
		border-radius: 5px;
		cursor: pointer;
		margin-right: 10px;
		transition: all 0.5s;
		font-size: 14px;
		-moz-transition: all 0.5s;
		/* Firefox 4 */
		-webkit-transition: all 0.5s;
		/* Safari and Chrome */
		-o-transition: all 0.5s;
		/* Opera */
	}

	.el-upload__text p {
		line-height: 28px;
	}


	.errorDialogContent {
		font-size: 18px;
		color: #333333;
	}

	.errorDialogContent span {
		color: var(--theme-red);
		text-decoration: underline;
		cursor: pointer;
	}

	.dialog-footer {
		margin-top: 10px;
		padding: 10px 20px 20px;
	}

	.dialog-footer .lookErrorBtn {
		padding: 10px 20px;
		background-color: var(--theme-red);
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 16px;
		cursor: pointer;
	}

	.stepTwo {}
	
	
	.stepTwo .project_Name_box,.stepTwo .downLoadModel{
		line-height: 50px;
	}
	
	.stepTwo .project_Name_box>a{
		color: #28c76f;
		font-weight: 700;
	}
	
	.stepTwo .stepTowlabel{
		color: #606266;
		font-size: 14px;
	}
	
	.stepThree .project_Name_box,.stepThree .downLoadModel{
		line-height: 50px;
	}
	
	.stepThree .project_Name_box>a{
		color: #28c76f;
		font-weight: 700;
	}
	
	.stepThree .stepTowlabel{
		color: #606266;
		font-size: 14px;
	}
	
	
	.stepThree {
		background-color: #FFFFFF;
		border-radius: 5px;
		margin-top: 15px;
	}

	.formatImg{ 
		position: absolute;left: 18px;top: 8px;
	}
	
	.regUnusually{
		color: #FFFFFF;background-color: #D0121B;padding: 5px;
	}

	/* .yaosuVerify a {
		display: inline-block;
		height: 30px;
		line-height: 30px;
		border: 1px solid var(--theme-white);
		border-radius: 15px;
		background-color: var(--theme-white);
		padding: 0 20px;
		color: #FFFFFF;
		box-shadow: 0 1px 4px var(--theme-white);
		-moz-box-shadow: 0 1px 4px var(--theme-white);
		-webkit-box-shadow: 0 1px 4px var(--theme-white);
		cursor: pointer;
	} */

	/* .yaosuVerify a:hover {
		background-color: var(--theme-btn);
	} */
	
	
	/* 清除原有input样式 */
	/* input[type="text"]{
		-web-kit-appearance:none;
		-moz-appearance: none;
		outline:0;
	};
	.threeExChangeInput{
		width: 80px;
		font-size: 22px;
		box-sizing: border-box;
		border-radius:6px;
		color:#6a6f77;
	}; */
	
	
	
	

	@media (max-width:767.78px) {

		.stepOne {
			padding: 15px 15px 15px 0;
		}

		.demo-ruleForm {
			padding-left: 0;
		}

		.operateBtn {
			padding-top: 10px;
		}

		.tabBtn {
			margin: 10px 0 0 10px;
		}

		.tabBtn li,
		.operateBtn li {
			float: left;
			padding: 0 5px;
			height: 20px;
			line-height: 20px;
			text-align: center;
			cursor: pointer;
			font-size: 8px;
		}

		.operateBtn li {
			margin-right: 5px;
		}

		.tableBox {
			padding: 0 !important;
		}

		.tableBox .titleBox {
			height: 40px;
		}
	}

	@media (max-width:1200.78px) {
		.fontStepF {
			font-size: 40px;
		}

		.cont_Box>div {
			padding: 0;
		}

		.cont_Box h3 {
			line-height: 30px;
			font-size: 15px;
		}

		.cont_Box p {
			font-size: 12px;
		}

		.step .hintDian1,
		.step .hintDian2 {
			line-height: 50px;
		}

		.step_BOX {
			height: 60px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/ProjectNew.vue